import {
  type DateInputValue,
  type TimeInputValue,
} from '@doxyme/ui/components/foundations';
import { isValidDate, isPastDate } from '@doxyme/ui/utils';
import { getFormattedDate, getFormattedTime } from '../helpers';
import { type MessageDescriptor, type PrimitiveType } from 'react-intl';

export const useFormattedDateTime = (
  dateField: DateInputValue,
  timeField: TimeInputValue,
  selectedLocaleFormatMessage: (
    descriptor: MessageDescriptor,
    values?: Record<string, PrimitiveType>,
  ) => string,
  language = 'en',
): string => {
  const isCorrectDate =
    dateField !== null && isValidDate(dateField) && !isPastDate(dateField);
  const isCorrectTime = timeField !== null && isValidDate(timeField);

  if (!isCorrectDate && !isCorrectTime) {
    return '';
  }

  return selectedLocaleFormatMessage(
    { id: 'inviteViaEmailForm.invitation.invitationTextDateTime' },
    {
      time: isCorrectTime
        ? `${getFormattedTime(timeField)}${isCorrectDate ? ',' : ''}`
        : '',
      date: isCorrectDate ? getFormattedDate(dateField, language) : '',
    },
  );
};
